/**
 * ArbiHunter API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: ROOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { BannerItemContentDTO } from '../models/BannerItemContentDTO';
import { HttpFile } from '../http/http';

export class BannerItemUpdateDTO {
    /**
    * Banner\'s language
    */
    'language'?: BannerItemUpdateDTOLanguageEnum;
    /**
    * Banner\'s title. Only for admin purposes.
    */
    'title'?: string;
    /**
    * Banner\'s position.
    */
    'position'?: BannerItemUpdateDTOPositionEnum;
    /**
    * Profile type, to which this banned should show.
    */
    'profileType'?: BannerItemUpdateDTOProfileTypeEnum;
    /**
    * If value is true, means that this banner will fill empty rotations.
    */
    'isDefault'?: boolean;
    /**
    * Banner\'s data for mobile.
    */
    'mobile'?: BannerItemContentDTO;
    /**
    * Banner\'s data for desktop.
    */
    'desktop'?: BannerItemContentDTO;
    /**
    * Amount of rotation, in decimal.
    */
    'rotation'?: number;
    /**
    * If value is true, means that this banner should show.
    */
    'isPublished'?: boolean;

    static readonly discriminator: string | undefined = undefined;

    static readonly mapping: {[index: string]: string} | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "language",
            "baseName": "language",
            "type": "BannerItemUpdateDTOLanguageEnum",
            "format": ""
        },
        {
            "name": "title",
            "baseName": "title",
            "type": "string",
            "format": ""
        },
        {
            "name": "position",
            "baseName": "position",
            "type": "BannerItemUpdateDTOPositionEnum",
            "format": ""
        },
        {
            "name": "profileType",
            "baseName": "profileType",
            "type": "BannerItemUpdateDTOProfileTypeEnum",
            "format": ""
        },
        {
            "name": "isDefault",
            "baseName": "isDefault",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "mobile",
            "baseName": "mobile",
            "type": "BannerItemContentDTO",
            "format": ""
        },
        {
            "name": "desktop",
            "baseName": "desktop",
            "type": "BannerItemContentDTO",
            "format": ""
        },
        {
            "name": "rotation",
            "baseName": "rotation",
            "type": "number",
            "format": ""
        },
        {
            "name": "isPublished",
            "baseName": "isPublished",
            "type": "boolean",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return BannerItemUpdateDTO.attributeTypeMap;
    }

    public constructor() {
    }
}

export enum BannerItemUpdateDTOLanguageEnum {
    EN = 'en',
    RU = 'ru',
    UK = 'uk'
}
export enum BannerItemUpdateDTOPositionEnum {
    HERO = 'HERO',
    SIDEBAR = 'SIDEBAR',
    TOP = 'TOP',
    LIST = 'LIST'
}
export enum BannerItemUpdateDTOProfileTypeEnum {
    EMPLOYEE = 'employee',
    HIRER = 'hirer',
    UNKNOWN = 'unknown'
}

